module.exports = __webpack_public_path__ + "media/application/images/ui/icon-close-lightgrey-3d1037eef2fb85deb5d3669b6bce9feb.png";